import { TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { DeviceService, UserService } from '@frontend/vanilla/core';

import { UserBannerService } from './user-banner.service';

@Component({
    selector: 'rewards-user-banner',
    imports: [DsButton, TitleCasePipe],
    styleUrls: ['./user-banner.component.scss'],
    templateUrl: './user-banner.component.html',
})
export class UserBannerComponent {
    @Input() userName: string;
    rewardsLabel: string;
    rewardsId: number;
    viewCardLabel: string;

    constructor(
        private userBannerService: UserBannerService,
        public deviceService: DeviceService,
        public userService: UserService,
    ) {}

    ngOnInit() {
        this.userBannerService.rewardsHubState.subscribe((data) => {
            if (data) {
                this.rewardsLabel = data['messages'].MGMRewardstext;
                this.rewardsId = data['messages'].MGMRewardsId;
                this.viewCardLabel = data['messages'].ViewCardButton;
            }
        });
    }
}
